<header class="mobile-topbar" [class.mobile-topbar-hidden]="isMenuOpen">
    <button type="button" class="topbar-button menu-button" (click)="toggleMenu()" aria-label="Menü öffnen">
        <mat-icon fontSet="material-icons-outlined">menu</mat-icon>
    </button>

    <div class="topbar-actions">
        <button type="button" class="theme-switch" [class.theme-switch-active]="themeService.currentTheme() === 'dark'"
            (click)="appSettingsService.toggleDarkMode()"
            [attr.aria-label]="themeService.currentTheme() === 'dark' ? 'Light Mode aktivieren' : 'Dark Mode aktivieren'">
            <span class="theme-switch-thumb">
                <mat-icon fontSet="material-icons-outlined">
                    {{ themeService.currentTheme() === 'dark' ? 'dark_mode' : 'light_mode' }}
                </mat-icon>
            </span>
        </button>

        <button type="button" class="topbar-button logout-button" (click)="logout()" aria-label="Abmelden">
            <mat-icon fontSet="material-icons-outlined">logout</mat-icon>
        </button>
    </div>
</header>